import { useParams } from "react-router-dom";
import ReleasePage from "./ReleasePage";

export default function ReleasePageWrapper() {
  const { slug } = useParams();
  return <ReleasePage slug={slug} />;
}
